if (window.enableDebugMode) { console.log('🏔️ Starting theme entry point...'); }

import 'vite/modulepreload-polyfill';

// Import Alpine.js and plugins
import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';
import focus from '@alpinejs/focus';
import morph from '@alpinejs/morph';
import persist from '@alpinejs/persist';
import intersect from '@alpinejs/intersect'

import '@js/mixins/action';
import '@js/actions/index';
import '@js/services/EventTracking';

import '@js/services/ActionHandler';

// // Import Alpine.js magic functions, stores, and components
// import alpineSetup from '../js/alpine/index.js';

// Import custom Alpine components and utilities
// import './modules/alpine/components.js';
// import './modules/alpine/directives.js';
// import './modules/alpine/stores.js';
// import './modules/utilities.js';
// import './modules/shopify.js';

// Define mobile breakpoint (matching globals.jsx)
export const mobileBreakpoint = '1024px';

// Performance monitoring utility
const perfMonitor = {
  marks: new Map(),
  mark(name) {
    if (window.performance?.mark) {
      performance.mark(name);
      this.marks.set(name, performance.now());
    }
  },
  measure(name, startMark) {
    if (window.performance?.measure && startMark) {
      performance.measure(name, startMark);
      const duration = performance.now() - this.marks.get(startMark);
      if (window.enableDebugMode) { console.log(`⏱️ ${name}: ${duration.toFixed(2)}ms`); }
    }
  }
};

const alpineSetup = (Alpine) => {
  // Alpine stores
  const alpineStores = import.meta.glob('@js/stores/**/*.js', { eager: true, import: 'default' })
  for (const path in alpineStores) {
    const store = alpineStores[path]
    const name = store.name
    Alpine.store(name, store.store())
  }

  // Alpine components
  const alpineComponents = import.meta.glob('@js/components/**/*.js', { eager: true, import: 'default' })
  for (const path in alpineComponents) {
    const component = alpineComponents[path]
    const name = component.name
    Alpine.data(name, component.component)
  }

  // Alpine magic properties
  const alpineMagic = import.meta.glob('@js/magic/**/*.js', { eager: true, import: 'default' })
  for (const path in alpineMagic) {
    const magic = alpineMagic[path]
    const name = magic.name
    Alpine.magic(name, magic.magic)
  }
};

// Start performance monitoring
perfMonitor.mark('alpine-init-start');

// Configure Alpine.js plugins
Alpine.plugin(collapse);
Alpine.plugin(focus);
Alpine.plugin(morph);
Alpine.plugin(persist);
Alpine.plugin(intersect);

// Register Alpine.js magic functions, stores, and components
alpineSetup(Alpine);

// Global Alpine data and utilities
window.Alpine = Alpine;

// Initialize Alpine when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  perfMonitor.mark('alpine-start-start');
  
  // Start Alpine
  Alpine.start();
  
  perfMonitor.measure('Alpine.js Startup', 'alpine-start-start');
  perfMonitor.measure('Total Alpine Init', 'alpine-init-start');
  
  if (window.enableDebugMode) { console.log('🏔️ Alpine.js theme initialized successfully'); }
});

// Global error handling
window.addEventListener('error', (event) => {
  console.error('Theme Error:', {
    message: event.message,
    filename: event.filename,
    lineno: event.lineno,
    colno: event.colno,
    error: event.error
  });
});

document.addEventListener('alpine:init', () => {
  if (window.enableDebugMode) { console.log('🏔️ Alpine.js initialized'); }
});

document.addEventListener('alpine:initialized', () => {
  if (window.enableDebugMode) { console.log('✅ Alpine.js fully loaded and components registered'); }
});

// Export for potential external use
export { Alpine, perfMonitor };